import Dispatcher from "Dispatcher";
import { ReduceStore } from "flux/utils";
import dotProp from "dot-prop-immutable";
import TwoPaneMultiSelectTypes
    from "lib/common/twopanemultiselect/data/TwoPaneMultiSelectTypes";

class TwoPaneMultiSelectStore extends ReduceStore {

    getInitialState() {
        return {
            groups: [],
            selection: {},
            scrollState: {
                selected: {
                    positions: {},
                    currentPos: 0,
                    title: "",
                },
                unselected: {
                    positions: {},
                    currentPos: 0,
                    title: "",
                },
            },
        };
    }

    getScrollState() {
        return this.getState().scrollState;
    }

    getGroups() {
        return this.getState().groups;
    }

    getSelection() {
        return this.getState().selection;
    }

    calculatePositions(state, source) {
        const positions = {};

        this.getGroups()
            .map(g => g.key)
            .forEach(k => {
                const header = document.querySelector(`#two-pane-${source}-${k}`);
                const items = document.querySelectorAll(`#two-pane-${source}-${k} a[data-group=${k}]`);
                const lastItem = items[items.length - 1];

                if (items.length > 0) {
                    positions[k] = [
                        header.offsetTop,
                        lastItem.offsetTop,
                    ];
                }
            });

        state = dotProp.set(
            state,
            `scrollState.${source}.positions`,
            positions,
        );

        return this.setTitle(state, source);
    }

    setTitle(newState, source) {
        const {
            scrollState,
        } = newState;

        const pos = scrollState[source].currentPos;

        if (!_.isEmpty(scrollState[source].positions)) {
            this.getGroups().forEach(g => {
                const k = g.key;
                if (scrollState[source].positions.hasOwnProperty(k)) {
                    const p0 = scrollState[source].positions[k][0];
                    const p1 = scrollState[source].positions[k][1];

                    if (p0 <= pos && pos <= p1) {
                        newState = dotProp.set(
                            newState,
                            `scrollState.${source}.title`,
                            g.name,
                        );
                    }
                }
            });
        }
        return newState;
    }

    reduce(state, action) {
        const {
            source,
            groups,
            prevGroups,
        } = action;

        switch (action.type) {
            case TwoPaneMultiSelectTypes.TOGGLE_ITEM:
                const groupPath = [
                    "selection",
                    action.groupKey,
                ];
                if (!state.selection.hasOwnProperty(action.groupKey)) {
                    // no group - must be a new exclude
                    return dotProp.set(state, groupPath, [action.itemKey]);
                }

                let items = state.selection[action.groupKey];
                const i = items.indexOf(action.itemKey);
                if (i < 0) {
                    // append it
                    return dotProp.set(
                        state,
                        groupPath,
                        v => v.concat(action.itemKey),
                    );
                }
                if (items.length === 1) {
                    // the only one
                    return dotProp.delete(state, groupPath);
                } else {
                    items = items.slice(); // duplicate
                    items.splice(i, 1);
                    return dotProp.set(state, groupPath, items);
                }

            case TwoPaneMultiSelectTypes.POPULATE:
                return {
                    ...this.getInitialState(),
                    groups,
                    selection: action.selection,
                };

            case TwoPaneMultiSelectTypes.HANDLE_SCROLL:
                state = dotProp.set(
                    state,
                    `scrollState.${source}.currentPos`,
                    action.top,
                );

                ["selected", "unselected"].forEach(source => {
                    if (_.isEmpty(state.scrollState[source].positions)) {
                        state = this.calculatePositions(state, source);
                    }
                });

                state = this.setTitle(state, source);

                return state;

            case TwoPaneMultiSelectTypes.UPDATE_POSITIONS:
                if (!_.isEqual(prevGroups, groups)) {
                    ["unselected", "selected"].forEach(source => {
                        state = this.calculatePositions(state, source);
                    });
                }

                return state;

            default:
                return state;
        }
    }
}

export default new TwoPaneMultiSelectStore(Dispatcher);



// WEBPACK FOOTER //
// ./app/lib/common/twopanemultiselect/data/TwoPaneMultiSelectStore.js